export default __webpack_public_path__ + "static/media/luxury_next.670e57a8.png";